import { useCallback, useEffect, useState } from "react";
import { Menu, Image } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import LogoFull from "../../assets/images/logo-full.png";
import DashboardIcon from "../../assets/icons/favorite-chart.svg";
import DashboardActiveIcon from "../../assets/icons/favorite-chart-active.svg";
import DealsIcon from "../../assets/icons/receipt-discount.svg";
import DealsActiveIcon from "../../assets/icons/receipt-discount-active.svg";
import OrdersIcon from "../../assets/icons/orders-icon.svg";
import OrdersActiveIcon from "../../assets/icons/orders-active-icon.svg";
import ReportsIcon from "../../assets/icons/reports-icon.svg";
import ReportsActiveIcon from "../../assets/icons/reports-active-icon.svg";
import WalletIcon from "../../assets/icons/wallet-icon.svg";
import WalletActiveIcon from "../../assets/icons/wallet-active-icon.svg";
import SupportIcon from "../../assets/icons/support-icon.svg";
import SupportActiveIcon from "../../assets/icons/support-active-icon.svg";
import "./Sidebar.scss";

const SidebarContent = ({ collapsed, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState(location.pathname);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768); // True for small screens
    };

    handleResize(); // Set initial value on component mount
    window.addEventListener("resize", handleResize); // Listen to window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up on unmount
    };
  }, []);

  const icon = (menuItemKey, activeIcon, inactiveIcon) => {
    return (
      <Image
        src={selectedKey === menuItemKey ? activeIcon : inactiveIcon}
        preview={false}
      />
    );
  };

  // List of menu items
  const allMenuItems = [
    {
      key: "/dashboard",
      icon: icon("/dashboard", DashboardActiveIcon, DashboardIcon),
      label: "Dashboard",
    },
    {
      key: "/live-deals",
      icon: icon("/live-deals", DealsActiveIcon, DealsIcon),
      label: "Live Deals",
    },
    {
      key: "/orders",
      icon: icon("/orders", OrdersActiveIcon, OrdersIcon),
      label: "Orders",
    },
    {
      key: "/reports",
      icon: icon("/reports", ReportsActiveIcon, ReportsIcon),
      label: "Reports",
    },
    {
      key: "/wallet",
      icon: icon("/wallet", WalletActiveIcon, WalletIcon),
      label: "Wallet",
    },
    // Conditionally render "Support" only on small screens
    ...(isSmallScreen
      ? [
          {
            key: "/support",
            icon: icon("/support", SupportActiveIcon, SupportIcon),
            label: "Support",
          },
        ]
      : []),
  ];

  const getSelectedKey = useCallback(() => {
    const dealPaths = [
      "/live-deals",
      "/deal-details",
      "/order-summary",
      "/agreement",
      "/success",
    ];

    if (dealPaths.some((path) => location.pathname.startsWith(path))) {
      return "/live-deals";
    }

    return location.pathname;
  }, [location.pathname]);

  useEffect(() => {
    setSelectedKey(getSelectedKey());
  }, [getSelectedKey, location.pathname]);

  const handleMenuItemClick = (e) => {
    navigate(e.key);
    onClose();
  };

  return (
    <>
      <div className="logo-container">
        <Image
          src={collapsed ? Logo : LogoFull}
          className="logo"
          preview={false}
        />
      </div>
      <Menu
        mode="inline"
        selectedKeys={[selectedKey]}
        className="custom-menu"
        onClick={handleMenuItemClick}
        items={allMenuItems.map((item) => ({
          key: item.key,
          icon: item.icon,
          label: !collapsed ? item.label : "",
        }))}
      />
    </>
  );
};

export default SidebarContent;
